import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { environment } from '../../../environments/environment';
import { Log } from 'ng2-logger';

const log = Log.create('ImageUpload');

@Component({
  moduleId: module.id,
  templateUrl: 'imageupload.component.html',
  selector: 'image-upload',
  styleUrls: ['imageupload.less']
})
export class ImageUploadComponent {
  _image: string;
  _label: string;
  imageResponse: any;
  BASE_URL: string = environment.BASE_URL;
  disabledValue: boolean = false;

  constructor(private admin: AdminService) { }

  @Output() imageChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() get disabled()   { return this.disabledValue; }

  @Input() get image() { return this._image; }
  @Input() get label() { return this._label; }

  set disabled(val) {
    this.disabledValue = val;
  }

  set image(val) {
    if (val != null && val.startsWith('http')) {
      this.BASE_URL = '';
    }
    this._image = val;
    this.imageChange.emit(this._image);
  }

  set label(val) {
    this._label = val;
  }

  private deleteImage() {
    this.image = null;
    this.imageResponse = null;
  }

  private processImage(event) {
    this.imageResponse = 'uploading';
    this.admin.postImage(event).subscribe
    (
      (data) => {
        this.imageResponse = data;
        this.image = data.data.url;
      },
      (error) => {
        this.imageResponse = 'error';
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/imageupload/imageupload.component.ts